
if (sessionStorage.getItem('dates') && sessionStorage.getItem('filterQuery')) {
  // General navigation links
  const linkBtns = document.querySelectorAll("#HeaderMenu-rent, #HeaderMenu-rent-women, #HeaderMenu-rent-men, #HeaderMenu-rent-juniors, .desktop-view-all a, .mobile-view-all a, .collections-banner__button, #HeaderDrawer-rent-women, #HeaderDrawer-rent-men, #HeaderDrawer-rent-juniors, #footer-women, #footer-men, #footer-juniors, .product-type-section-top a, .collection-link-all, .collection-link-category");
  linkBtns.forEach(el => {
    el.addEventListener("click", handleNavigationClick);
  });

  // Use event delegation for back-to-all links
  document.body.addEventListener("click", (e) => {
    if (e.target.closest('.collection-content .back-to-all')) {
      e.preventDefault();
      const backLink = e.target.closest('.back-to-all');
      handleBackToAllClick(backLink);
    }
    
    if (e.target.closest('.collection-link-type')) {
      e.preventDefault();
      const typeLink = e.target.closest('.collection-link-type');
      handleTypeLinkClick(typeLink);
    }
  });
}

function isMobile() {
    return window.innerWidth <= 991; 
}

function scrollToContent() {
    if (!isMobile()) return;
    
    const collectionContent = document.querySelector('.collection-content');
    if (collectionContent) {
        const headerHeight = 55;
        const offsetPosition = collectionContent.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({
            top: offsetPosition,
            behavior: 'instant'
        });
    }
}

// Navigation Handlers
function handleNavigationClick(e) {
    e.preventDefault();
    let baseUrl = this.getAttribute('href');
    let filterQuery = sessionStorage.getItem('filterQuery');
    
    if (!filterQuery.includes('page=')) {
        filterQuery += '&page=1';
    }
    
    let finalUrl = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${filterQuery}`;
    window.location.href = finalUrl;
}

function handleBackToAllClick(backLink) {
    const currentUrl = new URL(window.location.href);
    const currentParams = new URLSearchParams(currentUrl.search);
    let baseUrl = backLink.getAttribute('href');
    const category = currentParams.get('filter.p.tag');
    
    let finalUrl = `${baseUrl}?`;
    
    if (category) {
        finalUrl += `filter.p.tag=${category}`;
    }
    
    currentParams.forEach((value, key) => {
        if (key !== 'filter.p.product_type' && key !== 'filter.p.tag') {
            finalUrl += `${finalUrl.endsWith('?') ? '' : '&'}${key}=${value}`;
        }
    });
    
    // Clear the scroll flag when going back
    sessionStorage.removeItem('shouldScrollAfterLoad');
    
    window.location.href = finalUrl;
}

function handleTypeLinkClick(typeLink) {
    let baseUrl = typeLink.getAttribute('href');
    let type = typeLink.textContent.trim();
    let filterQuery = sessionStorage.getItem('filterQuery');
    
    if (!filterQuery.includes('page=')) {
        filterQuery += '&page=1';
    }

    if (isMobile()) {
      sessionStorage.setItem('shouldScrollAfterLoad', 'true');
    }
      
    let finalUrl = `${baseUrl}?filter.p.product_type=${type}&${filterQuery}`;
    window.location.href = finalUrl;
}

// See All Handlers
function attachSeeAllHandlers(elements) {
    elements.forEach(link => {
        if (link.dataset.handlerAttached) return;
        
        link.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // If we have session storage, handle all the filter logic
            if (sessionStorage.getItem('dates') && sessionStorage.getItem('filterQuery')) {
                const baseUrl = new URL(this.href);
                const currentSearch = window.location.search;
                const params = new URLSearchParams(currentSearch);
                
                const hasVendorFilter = Array.from(params.keys()).some(key => key === 'filter.p.vendor');
                const hasProductFilter = Array.from(params.keys()).some(key => key === 'filter.p.product_type');
                const hasActivityFilter = Array.from(params.keys()).some(key => key === 'filter.p.m.custom.activities');
                const hasColorFilter = Array.from(params.keys()).some(key => key === 'filter.v.t.shopify.color-pattern');
                
                let finalUrl = baseUrl.toString();
                
                if ((hasVendorFilter || hasActivityFilter || hasColorFilter || hasProductFilter) && sessionStorage.getItem('filterQuery')) {
                    const otherFilters = Array.from(params.entries())
                        .filter(([key]) => key !== 'filter.p.m.scf.avf')
                        .map(([key, value]) => `${key}=${value}`)
                        .join('&');
                        
                    const filterQuery = sessionStorage.getItem('filterQuery');
                    const availabilityValue = filterQuery.match(/filter\.p\.m\.scf\.avf=([^&]+)/)?.[1] || '';
                    
                    finalUrl += `?filter.p.m.scf.avf=${availabilityValue}${otherFilters ? '&' + otherFilters : ''}`;
                    
                    if (!otherFilters.includes('page=')) {
                        finalUrl += '&page=1';
                    }
                } else if (currentSearch) {
                    finalUrl += (baseUrl.search ? '&' : '?') + currentSearch.substring(1);
                    if (!currentSearch.includes('page=')) {
                        finalUrl += '&page=1';
                    }
                }

                if (isMobile()) {
                    sessionStorage.setItem('shouldScrollAfterLoad', 'true');
                }
                
                window.location.href = finalUrl;
            } else {
                // Simple navigation with scroll for non-sessionStorage case
                if (isMobile()) {
                    sessionStorage.setItem('shouldScrollAfterLoad', 'true');
                }
                window.location.href = this.href;
            }
            
            return false;
        });
        
        link.dataset.handlerAttached = 'true';
    });
}

// Initialize event listeners and observers
document.addEventListener("DOMContentLoaded", () => {
    // Initialize navigation links if required session storage items exist
    if (sessionStorage.getItem('dates') && sessionStorage.getItem('filterQuery')) {
        // General navigation links
        const linkBtns = document.querySelectorAll("#HeaderMenu-rent, #HeaderMenu-rent-women, #HeaderMenu-rent-men, #HeaderMenu-rent-juniors, .desktop-view-all a, .mobile-view-all a, .collections-banner__button, #HeaderDrawer-rent-women, #HeaderDrawer-rent-men, #HeaderDrawer-rent-juniors, #footer-women, #footer-men, #footer-juniors, .product-type-section-top a, .collection-link-all, .collection-link-category");
        linkBtns.forEach(el => {
            el.addEventListener("click", handleNavigationClick);
        });

        // Use event delegation for back-to-all and type links
        document.body.addEventListener("click", (e) => {
            if (e.target.closest('.collection-content .back-to-all')) {
                e.preventDefault();
                const backLink = e.target.closest('.back-to-all');
                handleBackToAllClick(backLink);
            }
            
            if (e.target.closest('.collection-link-type')) {
                e.preventDefault();
                const typeLink = e.target.closest('.collection-link-type');
                handleTypeLinkClick(typeLink);
            }
        });
    }

    // Set up observer for dynamically added "See All" links
    const seeAllObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                const newSeeAllLinks = document.querySelectorAll('a.see-all-link:not([data-handler-attached])');
                if (newSeeAllLinks.length) {
                    console.log('New SEE ALL links found:', newSeeAllLinks.length);
                    attachSeeAllHandlers(newSeeAllLinks);
                }
            }
        });
    });

    seeAllObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Attach handlers to existing "See All" links
    const existingLinks = document.querySelectorAll('a.see-all-link');
    if (existingLinks.length > 0) {
        console.log('Initial SEE ALL links found:', existingLinks.length);
        console.log('Current URL parameters:', new URLSearchParams(window.location.search).toString());
        attachSeeAllHandlers(existingLinks);
    }

    // Check if we should scroll after page load (mobile only)
    if (sessionStorage.getItem('shouldScrollAfterLoad') && isMobile()) {
        // Add a small delay to ensure content is rendered
        setTimeout(() => {
            scrollToContent();
            sessionStorage.removeItem('shouldScrollAfterLoad');
        }, 100);
    }

  if (!sessionStorage.getItem('dates') || !sessionStorage.getItem('filterQuery')) {
  document.body.addEventListener("click", (e) => {
    if (e.target.closest('.collection-link-type') || e.target.closest('.see-all-link')) {
      e.preventDefault();
      const link = e.target.closest('.collection-link-type') || e.target.closest('.see-all-link');
      const baseUrl = link.getAttribute('href');
      
      if (isMobile()) {
        sessionStorage.setItem('shouldScrollAfterLoad', 'true');
      }
      
      window.location.href = baseUrl;
    }
  });
}
});


